<template>
  <el-select class="td_select"
             v-model="values"
             default-first-option
             filterable
             remote
             reserve-keyword
             collapse-tags
             placeholder="请输入关键词"
             :clearable="clearable"
             :disabled="disabled"
             :loading="loading"
             :multiple="multiple">
    <el-option
      class="td_option"
      v-for="(item, index) in options"
      :key="index"
      :label="item.label"
      :value="item.value"
      @click.native="handleSelect(item)">
    </el-option>
  </el-select>
</template>
<script>

import { validatenull } from '@/tdcommon/validate'
import { getRegionDeptChildren } from '@/api/admin/dept'

export default {
  name: 'd2-container-operation-Regiondept',
  data () {
    return {
      values: [],
      options: [],
      loading: false
    }
  },
  props: {
    clearable: {
      type: Boolean,
      default: () => false
    },
    disabled: {
      type: Boolean,
      default: () => false
    },
    multiple: {
      type: Boolean,
      default: () => false
    },
    url: {
      type: String,
      default: () => ''
    },
    // searchType: 'area' 查区域，其他值查部门，默认 'area'
    searchType: {
      type: String,
      default: () => 'area'
    }
  },
  methods: {
    /**
     * 递归遍历树形结构，将所有节点按 isArea 分类收集到两个扁平数组中
     * @param {Array} tree  树节点数组
     * @param {Array} areaList   收集 isArea==='1' 的节点
     * @param {Array} deptList   收集 isArea!=='1' 的节点
     */
    flattenTree (tree, areaList, deptList) {
      if (!Array.isArray(tree)) return
      tree.forEach(node => {
        if (node.isArea === '1') {
          areaList.push({ label: node.name, value: node.deptId, raw: node })
        } else {
          deptList.push({ label: node.name, value: node.deptId, raw: node })
        }
        if (node.children && node.children.length > 0) {
          this.flattenTree(node.children, areaList, deptList)
        }
      })
    },
    remoteMethod (query) {
      this.loading = true
      getRegionDeptChildren(113).then(response => {
        this.loading = false
        if (response.code === 0) {
          const areaList = []
          const deptList = []
          this.flattenTree(response.data, areaList, deptList)
          // 根据 searchType 决定展示区域列表还是部门列表
          this.options = this.searchType === 'area' ? areaList : deptList
        }
      }).catch(() => {
        this.loading = false
      })
    },
    handleSelect (val) {
      this.$emit('change', val)
    }
  },
  watch: {
    values: function (val, oldVal) {
      this.$emit('input', val)
    },
    value: function (val, oldVal) {
      this.values = validatenull(val) ? [] : val
      this.remoteMethod(this.values)
      if (validatenull(this.values)) {
        this.$emit('change', [])
      }
    },
    // searchType 变化时重新拉取并过滤
    searchType: function () {
      this.remoteMethod(this.values)
    }
  },
  mounted () {
    this.remoteMethod(this.value)
  }
}
</script>

<style lang="scss" scoped>
</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/components/d2-container-operation-Regiondept/index.vue"
}
</vue-filename-injector>
